









import { Component, Vue } from "vue-property-decorator";
@Component({
    name: "dashBoard"
})
export default class dashBoard extends Vue {}
